import React from 'react';
import {
  CardActions,
  Button,
  Link,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';

const NullViewContent = ({ carousel }) => {
  const { isMobile } = useQuoteContext();

  const {
    benefits,
    cardTitle,
    learnMoreText
  } = fallbackViewTexts;

  return (
    <div
      data-testid="null-view-content"
      className={classNames(
        'sui-flex sui-flex-col sui-grow sui-justify-between',
        {
          'sui-ml-4 sui-p-2 sui-max-w-96 sui-gap-2 sui-h-full': carousel && !isMobile,
          'sui-max-w-lg sui-gap-4': !carousel && !isMobile,
          'sui-w-full sui-gap-2': isMobile
        }
      )}
    >
      <h3
        className={classNames(
          'sui-font-display sui-text-balance',
          {
            'sui-text-3xl': carousel,
            'sui-text-3xl @4xl:sui-text-6xl': !carousel
          }
        )}
      >
        {cardTitle}
      </h3>
      <ul className={classNames('sui-list-disc sui-list-outside sui-ml-4',
        {
          'sui-mb-4': !carousel
        }
      )}
      >
        {benefits.map((benefit, index) => (
          <li key={index}>
            <Typography>{benefit}</Typography>
          </li>
        ))}
      </ul>
      <CardActions>
        {
          // Carousel
          carousel && (
            <Link href="/c/create-a-quote">
              {learnMoreText}
            </Link>
          )
        }
        {
          // Mobile, non-carousel
          !carousel && isMobile && (
            <Button
              variant="secondary"
              fullWidth
              href="/c/create-a-quote"
            >
              {learnMoreText}
            </Button>
          )
        }
        {
          // Desktop, non-carousel
          !carousel && !isMobile && (
            <div className="sui-flex sui-flex-row sui-w-full">
              <div className="sui-w-full sui-grow @4xl:sui-hidden">
                <Button
                  variant="secondary"
                  fullWidth
                  href="/c/create-a-quote"
                >
                  {learnMoreText}
                </Button>
              </div>
              <div className="sui-hidden @4xl:sui-flex">
                <Button
                  variant="secondary"
                  fullWidth={false}
                  href="/c/create-a-quote"
                >
                  {learnMoreText}
                </Button>
              </div>
            </div>
          )
        }
      </CardActions>
    </div>
  );
};

NullViewContent.propTypes = {
  carousel: PropTypes.bool
};

NullViewContent.defaultProps = {
  carousel: false
};

export default NullViewContent;
